<template>
  <div id="apprMgmtBox">
        <div class="searchWrap">
            <div class="row">                
                <div class="itemWrap">
                    <span >專案名稱</span>
                    <el-select v-model="listQuery.ProjectName" placeholder="請選擇專案名稱" clearable style="width: 200px;">
                        <el-option label="全部" value="全部"></el-option>
                        <el-option v-for="(item , idx ) in projectNameList" :key="idx" :label="item" :value="item"></el-option>                        
                    </el-select>
                    <span >承辦人</span>
                    <el-select v-model="seletedStaff" placeholder="變更承辦人" clearable style="width: 200px;"  >
                        <el-option label="全部" value="全部"></el-option>
                        <el-option
                            v-for="item in branchStaffList"
                            :key="item.ID"
                            :label="item.UserName"
                            :value="item.UserID">
                        </el-option>
                    </el-select>
                </div>
                <div class="itemWrap">
                    <el-button style="margin-left: 20px;" type="primary" icon="el-icon-search" @click="doSearch">查詢</el-button>
                </div>
            </div>
        </div>  
        <div class="content" >
            <!--統計表-->
            <el-table ref="statsTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}"  style="width: 100%; margin-bottom: 20px;"  empty-text="暫無數據" :data="statsTable" >
                <el-table-column label="資料來源"  min-width="20%"> 
                    <template slot-scope="scope">
                        <span style="display: flex; align-items: center; gap: 10px;">
                            {{ scope.row.Source }} 
                            <!-- <span style="display: flex; align-items: center; gap: 5px;">
                                <el-button size="small" @click="btnWarningDetail(scope.row, scope.$index)">{{ scope.row.dueDesc }}</el-button>
                                <span v-if="scope.row.due" style="background-color: #f56c6c; color: white; border-radius: 50%; width: 24px; height: 24px; text-align: center; line-height: 24px; font-size: 12px; font-weight: bold;margin-left:-15px;z-index: 100;">{{ scope.row.due }}</span>
                            </span>                             -->
                        </span>
                    </template>               
                </el-table-column>               
                <el-table-column label="即將到期案件" prop="due"  min-width="12%" align="center" header-align="center">        
                    <template slot-scope="scope">
                        <template v-if="scope.row.due && scope.row.due > 0">
                            <el-button type="text" style="color: red;" @click="btnWarningDetail(scope.row, scope.$index)" class="goDetailPage">{{ scope.row.due }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="待分派" prop="pending"  min-width="12%" align="center" header-align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.pending && scope.row.pending > 0">
                            <el-button type="text" @click="btnClickDetail(scope.row,'待分派')" class="goDetailPage">{{ scope.row.pending }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>                                    
                </el-table-column>                                              
                <el-table-column label="待覆核-客戶拒絕" prop="客戶拒絕" min-width="12%" align="center" header-align="center">                
                    <template slot-scope="scope">
                        <template v-if="scope.row['客戶拒絕'] && scope.row['客戶拒絕'] > 0">
                            <el-button type="text" @click="btnClickDetail(scope.row,'待覆核-客戶拒絕')" class="goDetailPage">{{ scope.row['客戶拒絕'] }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>                                                        
                </el-table-column>                              
                <el-table-column label="待覆核-其他" prop="其他" min-width="12%" align="center" header-align="center"  >
                    <template slot-scope="scope">
                        <template v-if="scope.row['其他'] && scope.row['其他'] > 0">
                            <el-button type="text" @click="btnClickDetail(scope.row,'待覆核-其他')" class="goDetailPage">{{ scope.row['其他'] }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>                                                        
                </el-table-column>                         
                <el-table-column label="待覆核-撤件" prop="撤件" min-width="12%" align="center" header-align="center"  >
                    <template slot-scope="scope">
                        <template v-if="scope.row['撤件'] && scope.row['撤件'] > 0">
                            <el-button type="text" @click="btnClickDetail(scope.row,'待覆核-撤件')" class="goDetailPage">{{ scope.row['撤件'] }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>                                                        
                </el-table-column>     
                <el-table-column label="待覆核-續行申貸" prop="續行申貸" min-width="12%" align="center" header-align="center"   >                    
                    <template slot-scope="scope">
                        <template v-if="scope.row['續行申貸'] && scope.row['續行申貸'] > 0">
                            <el-button type="text" @click="btnClickDetail(scope.row,'待覆核-續行申貸')" class="goDetailPage">{{ scope.row['續行申貸'] }}</el-button>
                        </template>
                        <template v-else>
                            <span>0</span>
                        </template>
                    </template>                                                        
                </el-table-column>
            </el-table>
            <!-- 點選後, 呈現案件明細  -->
            <el-tabs v-model="activeTab" tab-position="top" type="border-card" v-if="showTabs" >
                <el-tab-pane :label="tabsTitle" name="tabsTitle">
                    <el-table ref="multipleTable" border :cell-style="{padding: '3px'}" :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}" style="width: 100%"  
                    empty-text="暫無數據" :data="tableData" >                         
                        <el-table-column label="案件編號"  prop="caseid" min-width="15%">
                            <template slot-scope="scope">
                                <el-button type="text" @click="btnOpDetail(scope.row)">{{ scope.row.CaseNo }}</el-button>
                            </template>
                        </el-table-column>                              
                        <el-table-column label="統一編號"  prop="UniComNm" min-width="15%">
                            <template slot-scope="scope">   
                                <el-tooltip content="將開啟新頁" placement="top">                                 
                                <a class="goDetailPage" @click="doShowCompanyDetail(scope.row)">{{ scope.row.UniComNm }}</a>
                                </el-tooltip>
                            </template>                       
                        </el-table-column>                          
                        <el-table-column label="公司名稱" prop="ComName"  min-width="25%"> 
                            <template slot-scope="scope">   
                                <el-tooltip content="將開啟新頁" placement="top">                    
                                <a class="goDetailPage" @click="doshowDetail(scope.row)">{{ scope.row.ComName }}</a>           
                                </el-tooltip>
                            </template>                                     
                        </el-table-column>                          
                        <el-table-column label="資料來源" prop="Source"  min-width="15%">                
                        </el-table-column>   
                        <el-table-column label="預計訪視時間" prop="ExpectVisitDt" min-width="15%">
                            <template slot-scope="scope">
                                {{ formatExpectVisitDisplay(scope.row) }}
                            </template>
                        </el-table-column>
                        <el-table-column label="案件狀態" prop="CaseStatus"  min-width="15%">                
                        </el-table-column>  
                        <el-table-column label="覆核狀態" prop="ApprovedStatus"  min-width="15%">                
                        </el-table-column>                                  
                        <el-table-column label="承辦人" prop="AssigneeUserName"  min-width="15%">                
                        </el-table-column>
                        <el-table-column label="專案名稱"  prop="ProjectName" min-width="15%"  >
                        </el-table-column>                         
                        <el-table-column label="到期日/限辨期限"  prop="DueDt" min-width="15%"  >
                        </el-table-column>     
                        <!--<el-table-column label="承辦人"  prop="AssigneeUserName" min-width="15%"   >                    
                        </el-table-column> 
                         <el-table-column label="企業資訊"  min-width="15%"   >
                            <template slot-scope="scope">                                   
                                <el-button type="text" @click="btnOpDetail(scope.row)">指派</el-button>                                
                            </template>
                        </el-table-column> -->
                    </el-table>                    
                </el-tab-pane>
            </el-tabs>
            <div class="pageBox" v-if="showTabs">
                <Pagination
                    @currentChange="pageChange"
                    :pageSize="this.listQuery.Page_Size"
                    :propsCurrentPage="this.listQuery.Page_Num"
                    :totalLists="totalLists">
                </Pagination>
            </div>              
        </div>
  
        <el-dialog title="案件明細" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="closeDialog" width="70%" center>
            <div class="dialogBox" >
                <div class="details-container">
                    <div class="detail-row">
                        <div class="detail-label">案件編號</div>
                        <div class="detail-content">{{ details[0] && details[0].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">到期日/限辦日期</div>
                        <div class="detail-content">{{ details[1] && details[1].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">統一編號</div>
                        <div class="detail-content">{{ details[2] && details[2].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">公司名稱</div>
                        <div class="detail-content">{{ details[3] && details[3].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">資料來源</div>
                        <div class="detail-content">{{ details[4] && details[4].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">專案名稱</div>
                        <div class="detail-content">{{ details[5] && details[5].value }}</div>
                    </div>
                    <div class="detail-row col-span-2" >
                        <div class="detail-label">案件狀態</div>
                        <div class="detail-content" >
                            <el-select disabled v-model="showDetails.CaseStatus" placeholder="請選擇案件狀態"  style="width:35%">
                            </el-select>
                            <el-select disabled v-model="showDetails.CaseReason" placeholder="請選擇原因" style="margin-left:10px; width: 35%;" >
                            </el-select>
                            <el-input type="input"  disabled v-model="showDetails.CaseReasonDescription" placeholder="請說明原因..." style="margin-left:10px; width: 100%;"></el-input>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">預計訪視時間</div>
                        <div class="detail-content">                            
                            <el-date-picker disabled v-model="showDetails.ExpectVisitDt" type="date" size="small" value-format="yyyy-MM-dd" style="width: 35%;margin-right:1rem;"></el-date-picker>
                            <el-radio disabled v-model="showDetails.vTime" label="10">上午</el-radio>
                            <el-radio disabled v-model="showDetails.vTime" label="14">下午</el-radio>
                        </div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">區處</div>
                        <div class="detail-content">{{ details[8] && details[8].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">分行名稱</div>
                        <div class="detail-content">{{ details[9] && details[9].value }}</div>
                    </div>
                    <!-- 續約欄位 -->
                    <div class="detail-row" v-if="reFieldVisible">
                        <div class="detail-label">ELN編號</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.ELNNo }}</div>
                    </div>
                    <div class="detail-row" v-if="reFieldVisible">
                        <div class="detail-label">餘額</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.CurrentAmount }}</div>
                    </div>    
                    <!-- 總行欄位 -->
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">信評等級</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.CreditRating }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">資本額</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.CapitalAmount }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">員工人數</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.EmployeeCount }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">台幣放款戶(Y/N)</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.TwdLoanAccountYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">有外幣存款(Y/N)</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.FxDepositAccountYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">衍生性金融商品(Y/N)</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.DerivativeProductYN }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">近一年貢獻度(千元)</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.LastYearContribution }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">外匯存款AUM(千元)</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.FxDepositAUM }}</div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">AUM</div>
                        <div class="detail-content">{{ this.selectedRow && this.selectedRow.TotalAUM }}</div>
                    </div>
                                                        
                    <div class="detail-row">
                        <div class="detail-label">覆核主管</div>
                        <div class="detail-content">{{ details[10] && details[10].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">承辦人</div>
                        <div class="detail-content" >{{ details[11] && details[11].value }}</div>
                        <div class="detail-content" v-if="assignBtnVisible">
                            <!-- 指派承辦人 --> 
                            <el-select v-model="seletedStaff" placeholder="變更承辦人" clearable style="width: 200px;" @change="changeStaff" >
                                <el-option
                                    v-for="item in branchStaffList"
                                    :key="item.ID"
                                    :label="`${item.UserName} (${item.RoleName})`"
                                    :value="item.ID">
                                </el-option>
                            </el-select>
                        </div>
                        
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">建立時間</div>
                        <div class="detail-content">{{ details[12] && details[12].value }}</div>
                    </div>
                    <div class="detail-row">
                        <div class="detail-label">備註</div>
                        <div class="detail-content">{{ showDetails.Memo }}</div>
                    </div>                      
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註1</div>
                        <div class="detail-content"> {{ showDetails.Memo1 }} </div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註2</div>
                        <div class="detail-content"> {{ showDetails.Memo2 }} </div>
                    </div>
                    <div class="detail-row" v-if="hqFieldVisible">
                        <div class="detail-label">備註3</div>
                        <div class="detail-content"> {{ showDetails.Memo3 }} </div>
                    </div>
                    

                    

                    
                    <!-- <div class="detail-row span-full">
                        <div class="detail-label">覆核意見</div>
                        <div class="detail-content">
                            <el-input type="textarea" :rows="2" v-model="apprMemo" placeholder="請輸入覆核意見" ></el-input>
                        </div>
                    </div>                     -->
                </div>  
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="showCaseHistory"><font-awesome-icon icon="history" style="margin-right:5px;" />查看案件歷程</el-button>
                    <el-button type="primary" v-if="editBtnVisible && !submitOrNot "  @click="btnEditDetail()"><font-awesome-icon icon="edit" style="margin-right:5px;" />編輯</el-button>
                    <el-button type="success" v-if="saveBtnVisible" @click="btnSaveDetail()"><font-awesome-icon icon="plus" style="margin-right:5px;" />{{ btnSaveTitle }}</el-button>
                    <el-button type="primary"  v-if="assignBtnVisible" @click="assignBtn()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />{{ assignBtnTitle }}</el-button>
                    <el-button type="primary"  v-if="btnApprove" @click="apprBtn()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />覆核</el-button>
                    <el-button type="success"  v-if="btnApprove" @click="rejectBtn()" ><font-awesome-icon icon="edit"  style="margin-right:5px;" />退回</el-button>                    
                    <el-button type="danger"  @click="closeDialog()" ><font-awesome-icon icon="times"  style="margin-right:5px;" />關閉</el-button>                    
            </span>
        </el-dialog>          
        

        <!-- 案件歷程 drawer -->
        <el-drawer
            :visible.sync="historyDrawerVisible"
            direction="rtl"
            size="40%">
            <template slot="title">
                <span style="font-size: 20px; font-weight: bold;">案件歷程</span>
            </template>
            <div style="padding: 20px;">
                <el-table :data="caseHistoryData" border stripe style="width: 100%">
                    <el-table-column prop="TriggerDt" label="建立時間" min-width="150" :formatter="formatDateTimeToMinute"></el-table-column>
                    <el-table-column prop="ActionType" label="類型" min-width="120"></el-table-column>
                    <el-table-column prop="TriggerUserName" label="異動人" min-width="100"></el-table-column>
                    <el-table-column prop="AssigneeUserName" label="核准人" min-width="100"></el-table-column>
                    <el-table-column prop="Memo" label="備註" min-width="150"></el-table-column>
                    
                </el-table>
                <div style="margin-top: 20px; text-align: right;">
                    <el-button type="primary" @click="historyDrawerVisible = false">關閉</el-button>
                </div>
            </div>
        </el-drawer>             
  </div>
</template>

<script>
import Pagination from '@/components/Pagination.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import { notify, handleError } from '@/utils/notify.js';
  
export default {
  components: {
    Pagination
  },
      data() {
        return {
            // 🆕 新增這兩個變數，用來記憶點擊狀態
            lastClickedRow: null,
            lastClickedStatus: "", // 可以是 '待分派', '待覆核-客戶拒絕', '即將到期' ...

            assignBtnTitle: "指派", // 指派按鈕文字(只有案件狀態為待分派時是”指派”，其他狀態時是”改派”)
            assignBtnVisible: true,
            apprMemo: "", // 主管的覆核意見
            seletedStaff: "",
            activeTab: '待分派', // 預設顯示待指派標籤頁
            details: {},
            keyword: "",
            dialogVisible: false,
            tableData: [],
            detailAllCases: [], // 明細模式完整資料(供 client-side 分頁)
            currentTableMode: 'main', // main: 全部列表, detail: 統計點選明細
            reviewTable: [],            
            btnName: "編輯",
            branchStaffList: [],
            showTabs: false,

            btnAssign: false,
            btnApprove: false,
            reFieldVisible: false, // 續約欄位顯示控制
            hqFieldVisible: false, // 總行欄位顯示控制

            // 案件歷程相關
            historyDrawerVisible: false,
            caseHistoryData: [],
            selectedRow: null,            

            dt: [],

            totalLists:0,
            keyword: "",  

            pickerOptions: {
                shortcuts: [{
                    text: '最近一週',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三個月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },          
                showDetails: {
                    CaseStatus: "",
                    CaseReason: "",
                    CaseReasonDescription: "",
                    ExpectVisitDt: "",
                    vTime: "10",
                    Memo: "",
                    Memo1: "",
                    Memo2: "",
                    Memo3: ""
                }  ,

            listQuery: {
                ProjectName:"",
                searchContent:"",
                Page_Size:10,
                Page_Num:1
            },   
            details: {},

            projectNameList: [],
            // 統計表格數字 (每列為一個資料來源，內含待分派與各類待覆核數量)
            statsTable: [],
            tabsTitle: "",
            status_transion: [
                {'待安排訪視': ['待安排訪視','客戶拒絕', '其他', '已安排訪視']},
                {'已安排訪視': ['已安排訪視','已訪視']},
                {'已訪視': ['已訪視','撤件', '續行申貸', '已安排訪視']}                
            ],
            nextSelectList: [],            
            showReason: false,
            ReasonList: [
                {"客戶拒絕": ['對產品/服務不感興趣', '要求特定時間再聯繫', '暫無資金需求','已有往來行庫', '其他']},
                {"其他": ['重覆名單', '聯絡方式錯誤','聯絡不上','停歇業', '其他']},
                {"撤件": ['訪談後無意願', '要求特定時間再聯繫', '其他']}
            ],
            selectedReason: [],
            editBtnVisible: false, // 編輯按鈕顯示控制
            submitOrNot: false, // 若已申請覆核, 則不可再編輯
            saveBtnVisible: false, // 儲存按鈕顯示控制
        }        

        
    },
    methods: {

        formatExpectVisitDisplay(row) {
            if (!row || !row.ExpectVisitDt) return '';

            const dateText = String(row.ExpectVisitDt).split('T')[0];
            const rawStartTime = row.ExpectVisitStartTime || row.Expect_Visit_Start_Time || '';
            const hour = parseInt(String(rawStartTime).split(':')[0], 10);
            const period = (!Number.isNaN(hour) && hour >= 12) ? '下午' : '上午';

            return `${dateText} ${period}`;
        },

        appendSearchFilters(qry) {
            if (this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部') {
                qry.Project_Name = this.listQuery.ProjectName;
            }

            if (this.seletedStaff && this.seletedStaff.trim() !== '全部') {
                const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                if (staff) {
                    qry.Assignee_User_ID = staff.UserID;
                }
            }
            return qry;
        },

        filterCasesByCurrentSearch(cases) {
            let filteredCases = Array.isArray(cases) ? [...cases] : [];

            if (this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部') {
                console.log('ProjectName filter applied:', this.listQuery.ProjectName);
                filteredCases = filteredCases.filter(c => c.ProjectName === this.listQuery.ProjectName);
            }

            if (this.seletedStaff && this.seletedStaff.trim() !== '全部') {                
                const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                console.log('Staff filter applied:', staff);
                if (staff) {
                    filteredCases = filteredCases.filter(c => c.AssigneeUserName === staff.UserName);
                }
            }

            return filteredCases;
        },

        formatDateTimeToMinute(row, column, cellValue) {
            const value = cellValue || (row && row[column && column.property]);
            if (!value) return '';

            const text = String(value).replace('T', ' ').trim();
            return text.length >= 16 ? text.slice(0, 16) : text;
        },

        formatCaseForDisplay(raw) {
            const item = Object.assign({}, raw);
            if( item.ApprovedStatus == 'approved' ){
                item.ApprovedStatus = '已覆核';
            } else if( item.ApprovedStatus == 'rejected' ){
                item.ApprovedStatus = '退回承辦';
            } else if( item.ApprovedStatus == 'pending' ){
                item.ApprovedStatus = '待覆核';
            }

            switch(item.CaseStatus) {
                case '待分派':
                    item.CaseStatus = '1.待分派';
                    break;
                case '待安排訪視':
                    item.CaseStatus = '2.待安排訪視';
                    break;
                case '已安排訪視':
                    item.CaseStatus = '3.已安排訪視';
                    break;
                case '客戶拒絕':
                    item.CaseStatus = '4.客戶拒絕';
                    break;
                case '其他':
                    item.CaseStatus = '5.其他';
                    break;
                case '已訪視':
                    item.CaseStatus = '6.已訪視';
                    break;
                case '撤件':
                    item.CaseStatus = '7.撤件';
                    break;
                case '續行申貸':
                    item.CaseStatus = '8.續行申貸';
                    break;
                case '核准':
                    item.CaseStatus = '9.核准';
                    break;
            }
            return item;
        },

        setPagedTableData(cases) {
            const all = Array.isArray(cases) ? cases : [];
            const pageSize = this.listQuery.Page_Size;
            const pageNum = this.listQuery.Page_Num;
            const start = (pageNum - 1) * pageSize;
            this.totalLists = all.length;
            this.tableData = all.slice(start, start + pageSize);
        },

        btnSaveDetail() {
            if( !this.details.CaseStatus || this.details.CaseStatus === '' ){
                notify({
                    title: "錯誤",
                    message: "案件狀態不能為空",
                    type: "error"
                });  
                return;
            }
            
            // 檢查showReason如果有顯示的話, details.CaseReason不能為空
            if( this.showReason && (!this.details.CaseReason || this.details.CaseReason === '') ){
                notify({
                    title: "錯誤",
                    message: "請選擇變更原因",
                    type: "error"
                });  
                return;
            }

            // 如果選擇的是"已安排訪視", 則details.ExpectVisitDt預計訪視時間不能為空
            if( this.details.CaseStatus === '已安排訪視' && (!this.details.ExpectVisitDt || this.details.ExpectVisitDt === '') ){
                notify({
                    title: "錯誤",
                    message: "當案件狀態為已安排訪視時，預計訪視時間不能為空",
                    type: "error"});  
                return;
            }

            // 儲存動作
            console.log("儲存案件明細", this.details);
            // 檢查如果ExpectVisitDt日期有值的話, details.CaseStatus不能為空
            if( this.details.ExpectVisitDt && (!this.details.CaseStatus || this.details.CaseStatus === '') ){
                notify({
                    title: "錯誤",
                    message: "當預計訪視時間有設定時，案件狀態不能為空",
                    type: "error"
                });  
                return;
            }
            const isPm = String(this.details.vTime || '10') === '14';
            const visitStartTime = isPm ? '14:00' : '10:00';
            const visitEndTime = isPm ? '16:00' : '12:00';

            const qry = {
                "ID": this.selectedRow.ID,
                "Case_Status": this.details.CaseStatus,
                "Expect_Visit_Dt": this.details.ExpectVisitDt,
                "Expect_Visit_Start_Time": this.details.ExpectVisitDt ? visitStartTime : '',
                "Expect_Visit_End_Time": this.details.ExpectVisitDt ? visitEndTime : '',
                "Memo": this.details.Memo
            }
            console.log("更新案件明細參數",qry);

            // 呼叫 API 更新案件明細
            this.$api.apicase.case_update(qry).then(response => {
                console.log("更新案件明細回應",response);
                this.getList(); // 重新載入列表資料
                
                this.showReason = false;

                notify({
                    title: "成功",
                    message: "案件明細已更新",
                    type: "success"
                });
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "更新案件明細失敗，請稍後再試",
                    type: "error"
                });                
            });

            if( this.details.CaseStatus == '續行申貸'  ){
                // 需要申請主管覆核
                const qry = {
                    "ID": this.selectedRow.ID,
                    "Case_Reason": this.details.CaseReason
                }
                this.$api.apicase.case_submit_approval(qry).then(response => {
                    console.log("申請主管覆核",response);
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "申請主管覆核失敗，請稍後再試",
                        type: "error"
                    });                
                });

            }


            if( this.showReason) {
                // 檢查如果理由是其他, this.details.CaseReasonDescription不能為空
                if( this.details.CaseReason === '其他' && (!this.details.CaseReasonDescription || this.details.CaseReasonDescription === '') ){
                    notify({
                        title: "錯誤",
                        message: "請填寫其他原因的說明",
                        type: "error"
                    });  
                    return;
                }
                //將原因記錄到案件申請覆核, 並準備申請主管覆核
                const qry = {
                    "ID": this.selectedRow.ID,
                    "Case_Reason": this.details.CaseReason,
                    "Case_Reason_Description": this.details.CaseReasonDescription,
                }
                this.$api.apicase.case_submit_approval(qry).then(response => {
                    console.log("申請主管覆核",response);
                }).catch(error => {
                    notify({
                        title: "錯誤",
                        message: "申請主管覆核失敗，請稍後再試",
                        type: "error"
                    });                
                });
            }
            this.editDetail = false;
            this.editBtnVisible = true;
            this.saveBtnVisible = false;
            // 關閉對話框
            this.dialogVisible = false;        
            
        },

        // 切換編輯狀態
        btnEditDetail() {
            this.editDetail = true;
            this.details.CaseStatus = '';// 先清空, 省得誤以為沒變更
            this.saveBtnVisible = true;
            this.editBtnVisible = false;            
        },  

        async btnWarningDetail(row, index) {

            // 🆕 記憶最後點擊的狀態（為了區分，我們把 status 設為 '即將到期'，並記錄 index）
            this.lastClickedRow = row;
            this.lastClickedStatus = '即將到期_' + index;
            
            console.log("點選的列資料", row);
            this.tabsTitle = `[${row.Source}] ${row.dueDesc}`;
            // 切換到明細 tab（名稱為 tabsTitle 的 tab pane）
            this.activeTab = 'tabsTitle';
            this.showTabs = true; // 顯示明細標籤頁
            this.currentTableMode = 'detail';
            this.listQuery.Page_Num = 1;
            let qry = {
                Source: row.Source,
                Page_Size: 9999,
                Page_Num: 1
            };
            if( index==0 || index == 1) // 續約, 總行
            {
                // Due_Start 與 Due_End 只要設定為前1000天與今天日期+30天即可
                qry.Due_Start = new Date(new Date().setDate(new Date().getDate() - 1000)).toISOString().split('T')[0]; // 今天日期-1000天                
                qry.Due_End = new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().split('T')[0]; // 今天日期+30天
                qry.IsCompleted = 'N';
            }
            else if( index==2 ) // 自行開發 
            {
                qry.Create_Start = new Date(new Date().setDate(new Date().getDate() - 1000)).toISOString().split('T')[0]; // 今天日期-1000天
                qry.Create_End = new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split('T')[0]; // 今天日期-90天
                qry.Case_Status = ['待安排訪視', '待分派'];                
            }

            const roleName = window.localStorage.getItem('userRole') || '';
            // UC角色, 若案件覆核後不該再能編輯，包括改派
            if( roleName.includes('UC')  ){
                this.btnAssign = true;
            }
            this.appendSearchFilters(qry);
            console.log("查詢案件明細參數", qry);
            const resp = await this.$api.apicase.case_list(qry);
            console.log("取得案件明細列表", resp);
            const filtered = this.filterCasesByCurrentSearch(resp.data);
            console.log("過濾後的案件列表", filtered);
            this.detailAllCases = filtered.map(item => this.formatCaseForDisplay(item));
            console.log("過濾後的案件列表", this.detailAllCases);
            this.setPagedTableData(this.detailAllCases);


            
        },

        async btnClickDetail(row, status) {

            // 🆕 記憶最後點擊的狀態
            this.lastClickedRow = row;
            this.lastClickedStatus = status;            

            console.log("點選的列資料", row);
            this.tabsTitle = `[${row.Source}] ${status}`;

            const roleName = window.localStorage.getItem('userRole') || '';
            // UC角色, 若案件覆核後不該再能編輯，包括改派
            if( roleName.includes('UC')  ){
                this.btnAssign = true;
            }

            // 切換到明細 tab（名稱為 tabsTitle 的 tab pane）
            this.activeTab = 'tabsTitle';
            this.showTabs = true; // 顯示明細標籤頁
            if( status.startsWith("待覆核") ){
                this.btnApprove = true;
                this.btnAssign = false;
                this.assignBtnVisible = false; // 待覆核時, 不顯示指派按鈕
            } else if( status === "待分派" ){
                this.btnApprove = false;
                this.btnAssign = true;
                this.assignBtnVisible = true; // 待分派時, 顯示指派按鈕
            }

            // 若 ApprovedStatus='pending', 不能改派或指派, 只能覆核或退回, 這時候指派按鈕也不顯示
            if( row.ApprovedStatus === 'pending' ){
                this.btnAssign = false;
            }



            // 根據案件狀態決定指派按鈕文字
            if( status == '待分派' ){
                this.assignBtnTitle = "指派";
            } else {
                this.assignBtnTitle = "改派";
            }            
            await this.getCellList(row.Source, status);
        },
        closeDialog() {
            this.editDetail = false;
            this.saveBtnVisible = false;
            this.dialogVisible = false;            
        },   
        
        
        async refreshCurrentList() {
            // 1. 先呼叫 getList(false) 更新上方的統計數字表格
            // 加上 await 確保統計 API 請求完成
            await this.getList(false);

            // 2. 關鍵：使用 $nextTick 讓 Vue 先把統計表格和 showTabs = false 的狀態渲染完成
            this.$nextTick(() => {
                // 3. 判斷剛才使用者是有點選特定數字，還是本來就在看全部列表
                if (this.lastClickedRow && this.lastClickedStatus) {
                    if (this.lastClickedStatus.startsWith('即將到期_')) {
                        const index = parseInt(this.lastClickedStatus.split('_')[1]);
                        this.btnWarningDetail(this.lastClickedRow, index);
                    } else {
                        this.btnClickDetail(this.lastClickedRow, this.lastClickedStatus);
                    }
                    
                    // 4. 雙重保險：強制指定當前 activeTab 的值，促使 el-tabs 重新聚焦
                    this.activeTab = 'tabsTitle';
                } else {
                    // 如果原本就沒有點選任何數字（看全部），就走原本的 getList
                    this.getList();
                }
            });
        },

        async getCellList(Source, Case_Status) {

            const reviewCats = ['客戶拒絕', '其他', '撤件', '續行申貸'];
            // if( Case_Status=="待分派" ) Case_Status = "待分派";
            if( Case_Status.startsWith("待覆核") ){
                Case_Status = Case_Status.replace("待覆核-","");
            }
            const qry = { Source: Source, Case_Status: [Case_Status], Page_Size: 255, Page_Num: 1 };
            if( reviewCats.includes(Case_Status) ){
                qry.Approved_Status = 'pending';
            }
            this.appendSearchFilters(qry);

            try {
                console.log("查詢案件明細參數", qry);
                const response = await this.$api.apicase.case_list(qry);
                this.currentTableMode = 'detail';
                this.listQuery.Page_Num = 1;
                const filtered = this.filterCasesByCurrentSearch(response.data);
                this.detailAllCases = filtered.map(item => this.formatCaseForDisplay(item));
                this.setPagedTableData(this.detailAllCases);
                console.log("取得案件明細列表", response);
            } catch (error) {
                notify({
                    title: "錯誤",
                    message: "獲取列表失敗，請稍後再試",
                    type: "error"
                });
            }
        },        

        loadProjectNameList() {

            const qry = {
                "Page_Num": 1,
                "Page_Size": 999
            }            
            this.$api.apicase.case_project(qry).then(response => {
                console.log("專案名稱列表",response.data);
                // 需要將response.data, distinct出專案名稱後, 才放入projectNameList, 需要保留ID, ProjectName二個欄位, 因為下拉選單需要用到ID, 顯示名稱則用ProjectName                
                this.projectNameList = [...new Set(response.data.map(item => item.ProjectName))];
                console.log("專案名稱列表(去重)", this.projectNameList);
            }).catch(error => {
                notify({
                    title: "錯誤",
                    message: "獲取專案名稱失敗，請稍後再試",
                    type: "error"
                });                
            });
        },

        // 主管指派承辦人
        assignBtn() {
            console.log("選擇的承辦人ID:", this.seletedStaff);
            if(!this.seletedStaff) {
                notify({
                    title: "警告",
                    message: "請選擇承辦人",
                    type: "warning"
                }); 
                return;
            }            
            // 從staffList中找到對應的使用者ID
            const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
            console.log("選擇的承辦人資料:", staff);            
            const qry = {
                "ID": this.selectedRow.ID,
                "Assignee_User_ID": staff.UserID,
                "Assignee_User_Name": staff.UserName,                
            }      
            // 依據按鈕文字來決定是否為第一次指派或改派，並設定 Is_Reassign 參數
            if(this.assignBtnTitle === "指派") {
                qry.Is_Reassign = false; // 第一次.. 要設成false,
            }
            if(this.assignBtnTitle === "改派") {
                qry.Is_Reassign = true; // 若是改派, 代表已經指派過了, 這次是改派, 要設成true
            }   

            this.$api.apicase.case_assign(qry).then(response => {
                console.log("指派結果",response);
                notify({
                    title: "成功",
                    message: "案件指派成功",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.seletedStaff = ''; // 清除指派用的承辦人選擇，避免 getList 誤用殘留值
                this.refreshCurrentList();               
            }).catch(error => {
                console.error("案件指派失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件指派失敗，請稍後再試",
                    type: "error"
                });                
            });      

        },

        changeStaff(value) {
            // console.log("選擇的承辦人:", value);
            // console.log("選擇的承辦人ID:", this.seletedStaff);
            // 從staffList中找到對應的使用者ID
            const staff = this.branchStaffList.find(item => item.ID === this.seletedStaff);
            console.log("選擇的承辦人資料:", staff);
            
            this.details[11].value = staff.UserName; // 更新 details 中的承辦人欄位

        },        

        // 主管覆核
        apprBtn(){

            // this.selectedRow 來決定要覆核的案件
            console.log("覆核案件", this.selectedRow);
            const qry = {
                "ID": this.selectedRow.ID,
                "Approved_Status": "approved",
                "Memo": this.apprMemo // 將覆核意見帶入 API 請求參數
            }
            this.$api.apicase.case_approve(qry).then(response => {
                console.log("覆核結果",response);
                notify({
                    title: "成功",
                    message: "案件覆核成功",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.refreshCurrentList();               
            }).catch(error => {
                console.error("案件覆核失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件覆核失敗，請稍後再試",
                    type: "error"
                });                
            });

        },

        // 主管退回
        rejectBtn(){
            // this.selectedRow 來決定要覆核的案件
            console.log("覆核案件", this.selectedRow);
            const qry = {
                "ID": this.selectedRow.ID,
                "Approved_Status": "rejected",
                "Memo": this.apprMemo // 將覆核意見帶入 API 請求參數
            }
            this.$api.apicase.case_approve(qry).then(response => {
                console.log("覆核結果",response);
                notify({
                    title: "成功",
                    message: "案件覆核拒絕，已退回承辦人",
                    type: "success"
                }); 
                this.dialogVisible = false;
                this.refreshCurrentList();               
            }).catch(error => {
                console.error("案件覆核失敗", error);
                notify({
                    title: "錯誤",
                    message: "案件覆核失敗，請稍後再試",
                    type: "error"
                });                
            });            

        },

        async showCaseHistory() {
            if (!this.selectedRow || !this.selectedRow.CaseNo) {
                notify({
                    title: "錯誤",
                    message: "無法取得案件編號",
                    type: "error"
                });
                return;
            }
            
            const qry = {
                "CaseID": this.selectedRow.ID,
                "Page_Size": 10,
                "Page_Num": 1
            };
            
            console.log("查詢案件歷程參數", qry);
            
            try {
                const response = await this.$api.apicase.case_history(qry);
                console.log("案件歷程資料", response);
                this.caseHistoryData = response.data || [];
                this.historyDrawerVisible = true;
            } catch (error) {
                console.error("取得案件歷程失敗", error);
                notify({
                    title: "錯誤",
                    message: "取得案件歷程失敗，請稍後再試",
                    type: "error"
                });
            }
        },          

        async pageChange(val) {
            this.listQuery.Page_Num = val;
            if (this.currentTableMode === 'detail') {
                this.setPagedTableData(this.detailAllCases);
                return;
            }
            await this.getList();
        
        },

       

        doshowDetail(row) {
            console.log(row);
            this.$queryRecord(this, row.ComName, 'company');  // 記錄點擊公司名
            const url = `/ctmMapCom?unicomnm=${row.UniComNm}`;
            window.open(url, '_blank');

        },        

        // 串到公司詳細資訊頁... http://localhost:1200/companyDetail?comid=90699843&comname=台泥東立綠能股份有限公司
        async doShowCompanyDetail(data) {
            console.log(data);
            const comid = data.UniComNm;
            const comname = data.ComName;

            this.$queryRecord(this, comname, 'company');  // 記錄點擊公司名
            // 開啟新視窗, 顯示公司詳細資訊
            const url = `/companyDetail?comid=${comid}&comname=${comname}`;
            window.open(url, '_blank');		
            
        },            

        async doSearch() {
            console.log("搜尋條件", this.listQuery);
            // 在這裡添加搜尋邏輯，例如發送請求到後端 API
            if( this.keyword && this.keyword.trim() !== '' )
                this.$queryRecord(this, this.keyword, 'keyword');  // 記錄搜尋關鍵字
            this.listQuery.Page_Num = 1; // 重置頁碼            
            await this.getList(false);    
            // this.tabsTitle = "查詢案件列表";        
        },



        async getList(showTableData=true) {
            const qry = {
                "Page_Size": this.listQuery.Page_Size,
                "Page_Num": this.listQuery.Page_Num
            }
            if( showTableData ){
                this.tabsTitle = "全部案件列表";
                this.activeTab = 'tabsTitle';     
                this.showTabs = true;       
                this.currentTableMode = 'main';
                this.detailAllCases = [];
            }
            else {
                this.showTabs = false;
            }

            console.log("取得列表資料", this.listQuery);
            if( this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部' ){
                qry.Project_Name = this.listQuery.ProjectName;
            }

            if( this.seletedStaff && this.seletedStaff.trim() !== '全部' ){
                console.log("選擇的承辦人ID:", this.seletedStaff);
                const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                if( staff ){
                    qry.Assignee_User_ID = staff.UserID; // 使用 UserID 查詢，非 row ID
                }
            }

            // 統計表格數字：依資料來源與案件狀態彙整數量
            const sources = ['續約重訂', '總行派案', '自行開發'];
            const reviewCats = ['客戶拒絕', '其他', '撤件', '續行申貸'];
            
            // 初始化統計資料
            const stats = sources.map(s => ({ Source: s, pending: 0 }));
            let allCases = []; // 定義為方法作用域變數

            try {
                // 第一次查詢：取得所有「待分派」案件
                const pendingQry = { 
                    Case_Status: ['待分派'], 
                    Page_Size: 255, 
                    Page_Num: 1 
                };
                console.log("待分派查詢參數:", pendingQry);
                const pendingResp = await this.$api.apicase.case_list(pendingQry);
                console.log("待分派查詢結果:", pendingResp);
                console.log("待分派資料筆數:", pendingResp.data ? pendingResp.data.length : 0);
                
                // 第二次查詢：取得所有「待覆核」案件
                const reviewQry = { 
                    Case_Status: reviewCats, 
                    Approved_Status: 'pending',
                    Page_Size: 255, 
                    Page_Num: 1 
                };
                console.log("待覆核查詢參數:", reviewQry);
                const reviewResp = await this.$api.apicase.case_list(reviewQry);
                console.log("待覆核查詢結果:", reviewResp);
                console.log("待覆核資料筆數:", reviewResp.data ? reviewResp.data.length : 0);

                // 第三次查詢,  統計即將到期案件數量（使用過濾後的數據）            
                // 若是續約重訂, 總行派案, 都是Due_Start ~ Due_End ,IsCompleted='N' , 再去分Source (Source='續約重訂' or Source='總行派案' ) 的案件數量
                const dueQry = {
                    Due_Start: new Date(new Date().setDate(new Date().getDate() - 1000)).toISOString().split('T')[0], // 今天日期-1000天
                    Due_End: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().split('T')[0], // 今天日期+30天
                    IsCompleted: 'N',
                    Page_Size: 500,
                    Page_Num: 1
                };            
                if( this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部' ){
                    dueQry.Project_Name = this.listQuery.ProjectName;
                }

                if( this.seletedStaff ){
                    console.log("選擇的承辦人ID:", this.seletedStaff);
                    const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                    if( staff ){
                        dueQry.Assignee_User_ID = staff.UserID; // 使用 UserID 查詢，非 row ID
                    }
                }                    
                const dueResp = await this.$api.apicase.case_list(dueQry);
                // console.log("即將到期查詢結果:", dueResp);
                // 統計Source為續約重訂 及 總行派案的案件數量(需要分開計算, 因為後續要顯示在統計表格的不同列)
                const dueCases = dueResp.data || [];
                const dueStats = { '續約重訂': 0, '總行派案': 0 };
                dueCases.forEach(c => {
                    if (c.Source === '續約重訂') {
                        dueStats['續約重訂']++;
                    } else if (c.Source === '總行派案') {
                        dueStats['總行派案']++;
                    }
                });                
                stats[0].due = dueStats['續約重訂'];
                stats[0].dueDesc = "到期日1個月內且尚未完成訪視";
                stats[1].due = dueStats['總行派案'];
                stats[1].dueDesc = "到期日1個月內且尚未完成訪視";

                // 若是自行開發, 則是Create_Start 到 Create_End 90天內到期的案件 邏輯是(CaseStatus='待安排訪視' or CaseStatus='待分派' ) 
                const crQry = {
                    Create_Start: new Date(new Date().setDate(new Date().getDate() - 1000)).toISOString().split('T')[0], // 今天日期-1000天
                    Create_End: new Date(new Date().setDate(new Date().getDate() - 90)).toISOString().split('T')[0], // 今天日期-90天
                    Case_Status: ['待安排訪視', '待分派'],
                    Source: '自行開發',
                    Page_Size: 10,
                    Page_Num: 1
                };
                if( this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部' ){
                    crQry.Project_Name = this.listQuery.ProjectName;
                }

                if( this.seletedStaff ){
                    console.log("選擇的承辦人ID:", this.seletedStaff);
                    const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                    if( staff ){
                        crQry.Assignee_User_ID = staff.UserID; // 使用 UserID 查詢，非 row ID
                    }
                }                    

                console.log("自行開發即將到期查詢參數:", crQry);
                const crResp = await this.$api.apicase.case_list(crQry);
                console.log("自行開發即將到期查詢結果:", crResp);
                if( crResp.data && crResp.statuscode==200 ){
                    stats[2].due = crResp.total; // 因為自行開發的待分派案件即是即將到期案件                    
                    
                } else {
                    stats[2].due = "0";                    
                }
                stats[2].dueDesc = "起案後3個月且尚未完成訪視";
                
                // JavaScript 統計運算：依資料來源分類
                // 併入到期案件，確保明細列表可包含即將到期案例
                const crDueCases = crResp.data || [];
                allCases = [
                    ...(pendingResp.data || []),
                    ...(reviewResp.data || []),
                    // ...dueCases,
                    // ...crDueCases
                ];

                console.log("合併前的所有案件筆數:", allCases.length);
                // 依案件主鍵去重，避免同一案件出現在多個查詢結果中
                const caseMap = new Map();
                allCases.forEach(c => {
                    const key = c.ID || c.CaseNo;
                    if( key && !caseMap.has(key) ){
                        caseMap.set(key, c);
                    }
                });
                allCases = Array.from(caseMap.values());
                console.log("合併後的所有案件筆數:", allCases.length);
                console.log("合併後的所有案件:", allCases);
                
                // 檢查資料結構
                if (allCases.length > 0) {
                    console.log("第一筆案件結構:", allCases[0]);
                    console.log("第一筆案件的所有鍵:", Object.keys(allCases[0]));
                    console.log("第一筆案件的 Source:", allCases[0].Source);
                }
                
                // 根據搜尋條件過濾統計用的數據
                let statsFilteredCases = [...allCases];
                if( this.listQuery.ProjectName && this.listQuery.ProjectName.trim() !== '全部' ){
                    statsFilteredCases = statsFilteredCases.filter(c => c.ProjectName === this.listQuery.ProjectName);
                }
                if( this.seletedStaff ){
                    const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                    if( staff ){
                        statsFilteredCases = statsFilteredCases.filter(c => c.AssigneeUserName === staff.UserName); // 以姓名比對，避免 ID 欄位名稱不確定
                    }
                }
                
                console.log('統計過濾後的案件筆數:', statsFilteredCases.length, '過濾後的案件:', statsFilteredCases);
                const safeSources = Array.isArray(sources) ? sources.slice(0, 20) : [];
                const safeReviewCats = Array.isArray(reviewCats) ? reviewCats.slice(0, 20) : [];
                
                for (let i = 0; i < safeSources.length; i++) {
                    const s = safeSources[i];
                    
                    // 統計該來源的「待分派」數量（使用過濾後的數據）
                    const pendingCount = statsFilteredCases.filter(c => c.Source === s && c.CaseStatus === '待分派').length;
                    stats[i].pending = pendingCount;
                    console.log(`${s} 待分派數:`, pendingCount);
                    
                    // 統計該來源各類「待覆核」數量（使用過濾後的數據）
                    for (const cat of safeReviewCats) {
                        const reviewCount = statsFilteredCases.filter(c => 
                            c.Source === s && 
                            c.CaseStatus === cat && 
                            c.ApprovedStatus === 'pending'
                        ).length;
                        stats[i][cat] = reviewCount;
                        console.log(`${s} 待覆核-${cat}數:`, reviewCount);
                    }
                }

                this.statsTable = stats;
                console.log('最終統計表格數字:', this.statsTable);
                
            } catch (error) {
                console.error("統計數據失敗", error);
                notify({
                    title: "錯誤",
                    message: "統計數據失敗，請稍後再試",
                    type: "error"
                });
            }
            
            if( !showTableData ) {
                this.activeTab = ''; // 不切換到明細 tab
                return; // 如果不需要顯示明細資料, 就直接返回
            }
            
            // 直接使用統計中已獲取的 allCases 數據，確保列表與統計表一致（只顯示 9 筆)
            let filteredCases = [...allCases];
            
            // 如果有搜尋條件，進一步過濾
            if( this.listQuery.ProjectName ){
                filteredCases = filteredCases.filter(c => c.ProjectName === this.listQuery.ProjectName);
            }
            if( this.seletedStaff ){
                const staff = this.branchStaffList.find(item => item.UserID === this.seletedStaff || item.ID === this.seletedStaff);
                if( staff ){
                    filteredCases = filteredCases.filter(c => c.AssigneeUserName === staff.UserName); // 以姓名比對，避免 ID 欄位名稱不確定
                }
            }
            // 針對 ApprovedStatus 做處理,  若是approved='已覆核'
            // 若是 'rejected' 則顯示 '退回承辦'
            // 若是 'pending' 則顯示 '待覆核'
            filteredCases.forEach(item => {
                if( item.ApprovedStatus == 'approved' ){
                    item.ApprovedStatus = '已覆核';
                } else if( item.ApprovedStatus == 'rejected' ){
                    item.ApprovedStatus = '退回承辦';
                } else if( item.ApprovedStatus == 'pending' ){
                    item.ApprovedStatus = '待覆核';
                }
                console.log('CaseStatus=======>', item.CaseStatus);
                switch(item.CaseStatus) {
                    case '待分派':
                        item.CaseStatus = '1.待分派';
                        break;
                    case '待安排訪視':
                        item.CaseStatus = '2.待安排訪視';
                        break;
                    case '已安排訪視':
                        item.CaseStatus = '3.已安排訪視';
                        break;
                    case '客戶拒絕':
                        item.CaseStatus = '4.客戶拒絕';
                        break;
                    case '其他':
                        item.CaseStatus = '5.其他';
                        break;
                    case '已訪視':
                        item.CaseStatus = '6.已訪視';
                        break;
                    case '撤件':
                        item.CaseStatus = '7.撤件';
                        break;
                    case '續行申貸':
                        item.CaseStatus = '8.續行申貸';
                        break;
                    case '核准':
                        item.CaseStatus = '9.核准';
                        break;
                }
            });
            console.log("列表數據:", filteredCases);
            this.totalLists = filteredCases.length;
            // client-side 分頁切割
            const pageSize = this.listQuery.Page_Size;
            const pageNum = this.listQuery.Page_Num;
            const start = (pageNum - 1) * pageSize;
            this.tableData = filteredCases.slice(start, start + pageSize);
            this.showTabs = true; // 顯示明細標籤頁
            console.log(`分頁：第${pageNum}頁，每頁${pageSize}筆，總${filteredCases.length}筆，本頁${this.tableData.length}筆`);
        },

        // 取得分行承辦人清單
        getBranchStaff() {
            const DeptID = window.localStorage.getItem('deptID');
            const qry = {
                "DeptID": DeptID,
                "isSys": true
            };
            console.log("取得分行承辦人清單參數", qry);
            this.$api.apidivison.contact_list_search(qry).then(response => {
                console.log("分行承辦人清單",response);                
                this.branchStaffList = response.data.filter(item => item.RoleName == "UC" || item.RoleName == "UAO") || [];
            }).catch(error => {
                console.error("獲取分行承辦人清單失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取分行承辦人清單失敗，請稍後再試",
                    type: "error"
                });                
            });
        },

        async btnOpDetail(row) {         
            // 根據 activeTab 決定要查詢的案件狀態, 若是"待分派", 
            console.log("activeTab", this.activeTab);
            
            this.selectedRow = row;
            const qry = { "ID": row.ID };
            console.log("取得案件詳細資訊參數",qry);
            await this.$api.apicase.case_detail(qry).then(response => {
                console.log("案件詳細資訊",response);
                row = response.data;
                const rawStartTime = row.ExpectVisitStartTime || row.Expect_Visit_Start_Time || '';
                const hour = parseInt(String(rawStartTime).split(':')[0], 10);
                const vTime = (!Number.isNaN(hour) && hour >= 12) ? '14' : '10';
                this.details = [
                    { title: "案件編號", value: row.CaseNo },
                    { title: "到期日/限辨期限", value: row.DueDt },
                    { title: "統一編號", value: row.UniComNm },
                    { title: "公司名稱", value: row.ComName },
                    { title: "資料來源", value: row.Source },                
                    { title: "專案名稱", value: row.ProjectName },
                    { title: "案件狀態", value: row.CaseStatus },
                    { title: "預計訪視時間", value: this.formatExpectVisitDisplay(row) },
                    { title: "區處", value: row.DivisionName  },
                    { title: "分行名稱 ", value: row.DeptName  },
                    { title: "覆核主管", value: row.ApproveUserName },
                    { title: "承辦人", value: row.AssigneeUserName  },               
                    { title: "建立時間", value: row.CreateDt  },                
                    { title: "備註", value: row.Memo },
                    { title: "原因", value: "" },
                    { title: "案件原因", value: row.CaseReason },
                    { title: "原因說明", value: row.CaseReasonDescription }
                ];
                this.showDetails = {
                    CaseStatus: row.CaseStatus,
                    CaseReason: row.CaseReason,
                    CaseReasonDescription: row.CaseReasonDescription,
                    ExpectVisitDt: row.ExpectVisitDt,
                    vTime,
                    Memo: row.Memo,
                    Memo1: row.Memo1,
                    Memo2: row.Memo2,
                    Memo3: row.Memo3,
                };

                // 找出目錄CaseStatus對應的下一步狀態選項
                // this.nextSelectList = [];
                // for( let i=0; i<this.status_transion.length; i++ ){
                //     const key = Object.keys(this.status_transion[i])[0];
                //     if( key === row.CaseStatus ){
                //         this.nextSelectList = this.status_transion[i][key];
                //         break;
                //     }
                // }

                // 根據資料來源決定是否顯示特定欄位
                if( row.Source === '總行派案' ){
                    this.hqFieldVisible = true;
                } else {
                    this.hqFieldVisible = false;                    
                }
                if( row.Source === '續約重訂' ){
                    this.reFieldVisible = true;
                } else {
                    this.reFieldVisible = false;                    
                }

                // 根據案件狀態決定指派按鈕文字
                if( this.showDetails.CaseStatus == '待分派' ){
                    this.assignBtnTitle = "指派";
                } else {
                    this.assignBtnTitle = "改派";
                }

                // 找出目錄CaseStatus對應的下一步狀態選項
                this.nextSelectList = [];
                for( let i=0; i<this.status_transion.length; i++ ){
                    const key = Object.keys(this.status_transion[i])[0];
                    if( key === row.CaseStatus ){
                        this.nextSelectList = this.status_transion[i][key];
                        break;
                    }
                }      

                // 若案件狀態為 pending, approved, rejected 則不可編輯
                this.submitOrNot = (row.ApprovedStatus == "pending" || row.ApprovedStatus == "approved") ? true : false;
                console.log("是否已申請覆核, 不可編輯:", this.submitOrNot);

                // 若案件狀態為pending, 則是UC的角色的人, 才可以覆核及退回
                const roleName = window.localStorage.getItem('userRole') || '';
                if( roleName.includes('UC') && row.ApprovedStatus == "pending" ){
                    this.btnApprove = true;
                } else {
                    this.btnApprove = false;
                }         

                // 若案件狀態為 rejected, 且是UAO的角色的人, 代表案件被退回承辦, 才可以修改案件
                if( roleName.includes('UAO') && row.ApprovedStatus == "rejected" ){
                    this.editBtnVisible = true;
                } else {
                    this.editBtnVisible = false;
                }
                console.log("是否顯示:", roleName, row.ApprovedStatus, this.btnApprove, this.editBtnVisible);

                // UC角色, 若案件"覆核後"及"待覆核"不該再能編輯，包括改派
                if( roleName.includes('UC') && (row.ApprovedStatus == "approved" || row.ApprovedStatus == "pending" ) ){
                    this.assignBtnVisible = false;
                } else
                   if( roleName.includes("UC"))
                       this.assignBtnVisible = true;                

                 // 根据权限和案件状态设置编辑按钮
                const userHasEditPermission = this.$store.getters.userMenu
                    ?.find(item => item.Name === "案件管理")?.Action
                    ?.some(item => item.Action === "修改案件") || false;
                this.editBtnVisible = userHasEditPermission && !this.submitOrNot;                      
                
                this.dialogVisible = true;

            }).catch(error => {
                console.error("獲取案件詳細資訊失敗", error);
                notify({
                    title: "錯誤",
                    message: "獲取案件詳細資訊失敗，請稍後再試",
                    type: "error"
                });                
            });
        }, 


    },
    async mounted() {
        
        this.getList(false);
        this.getBranchStaff();
        this.loadProjectNameList()
    }
}
</script>

<style lang="scss" scoped>
#apprMgmtBox {
  background: linear-gradient(-135deg, #FFF 20%, #fff 50%, transparent 50%)
    center center / 100% 100%;
  min-height: 100vh;
  padding: 0px 0%;
    .searchWrap   {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    padding: 0px 5%;
    .row {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            

            .itemWrap {
                span {
                    margin-right: 10px;
                    white-space: nowrap;
                }
                width: 100%;
                display: flex;
                flex-direction: row;
                align-items: center;                
                margin-top:10px; 
                margin-bottom: 10px;
                margin-right: 10px;
            }
        }    
    .row2 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-end;
        margin-bottom: 10px;
        .el-button {
            margin-right: 10px;
        }
    }
    
  }
    .content {
    display: flex;
    flex-direction: column;    
    justify-content: flex-start;
    margin-top: 20px;
    padding: 0px 5%;
    .legend {
        display: flex;
        flex-direction: row;
        .legendItem {
            width: 80px;
            margin: 5px 10px;
        }
        
    }

  }  
  .pageBox {
    display: flex;
    flex-direction: columns;    
    justify-content: flex-end;
    padding: 0px 5%;
   }   

   .apprbox {
    display: flex;
    flex-direction: row;    
    align-items: center;
    margin-top: 10px;
    span {
        font-weight: bold;
        margin-right: 10px;
        white-space: nowrap;
    }
   }
}

/* 添加對話框樣式 */
.dialogBox {
  .details-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 3px 3px;
    padding: 5px 10px;
  }

  .detail-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    // padding: 8px 10px;
    border-bottom: 1px solid #ebeef5;
    
    
    .detail-label {
        display: flex;
        align-items: center;
      min-width: 150px;
      max-width: 150px;
      font-weight: bold;
      color: #303133;
      text-align: right;
      padding-right: 12px;
      font-size: 14px;      
      flex-shrink: 0;
    }
    
    /* 讓 detail-row 橫跨兩欄 */
    &.col-span-2 {
        grid-column: 1 / -1;
        .detail-content {
            width: 100%;
        }
    }
    
    .detail-content {
        display: flex;
        align-items: center;
      flex: 1;
      color: #606266;
      font-size: 14px;      
      word-break: break-word;
    }
    
    &.span-full {
      grid-column: span 2;
    }
  }  

  .row1 {
        display: flex;
        flex-direction: row;    
        justify-content: flex-start;
        .itemBox {
            display: flex;
            flex-direction: row;    
            justify-content: flex-start;
            margin: 10px 10px;
            width: 50%;

            label {            
                margin-right: 10px;
                margin-top:10px;
                white-space: nowrap;
                font-weight: bold;
                font-size:medium;
            }
            button {
                text-align: center;
            }
        }
    }

  .detail-item {
    width: calc(50% - 20px); /* 一行兩個，減去邊距 */
    display: flex;
    margin: 5px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;    
    
    .detail-label {
      width: 30%;
      font-weight: bold;
      color: black;
      text-align: center;
      font-size: medium
    }
    
    .detail-content {
      width: 70%;      
      font-size: medium
    }
  }
  
  h3 {
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 16px;
    color: #303133;
    font-weight: 500;
  }
}

.goDetailPage {
    color: #0645ad;
    text-decoration: underline;
    cursor: pointer;
}

</style>